// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__32o6h","list":"styles_list__EUrE6"};